module.exports = __webpack_public_path__ + "img/mount-of-firelogo.50f7b22f.png";